import { TouchableOpacity, View } from "react-native";
import React, { useEffect, useState } from "react";
import { H6, SmallBoldTxt, SmallTxt } from "../../TextsComponents";
import { useTranslation } from "react-i18next";
import { EmailIcon } from "../../../assets/svg/MyAccountIcons";
import { Input } from "../../Inputs";
import { useSelector } from "react-redux";
import DimensionsHook from "../../../hooks/DimensionsHook";
import { PrimaryButton, SecondaryButton } from "../../Buttons";
import Spinner from "../../Spinner";
import { colors } from "../../../styles/GlobalStyle";
import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import ValidateChangeEmail from "./ValidateChangeEmail";
import { CloseIcon } from "../../../assets/svg/Appointment";
import { Ionicons } from "@expo/vector-icons";
import ValidateEmail from "./ValidateEmail";
import { Check } from "../../../assets/svg/Coaching";

const ChangeEmail = ({ scrollToTop, setErrorMessage }) => {
  const { email, status } = useSelector((state) => state.userData);

  const { t } = useTranslation();
  const { width } = DimensionsHook();
  const isDesktop = width > 900;
  const [emailValue, setEmailValue] = useState(email);
  const [isDisabled, setIsDisabled] = useState(true);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [showValidateEmail, setShowValidateEmail] = useState(false);
  const [showWarningMessage, setShowWarningMessage] = useState(true);
  const [submitVerifLoder, setSubmitVerifLoader] = useState(false);
  const [showVerifModal, setShowVerifModal] = useState(false);
  const verifHandler = async () => {
    if (!submitVerifLoder) {
      setSubmitVerifLoader(true);
      setErrorMessage("");
      const TOKEN = await AsyncStorage.getItem("access_token");
      axios
        .post(process.env.USER_SEND_CODE, {
          access_token: TOKEN,
        })
        .then(() => {
          setSubmitVerifLoader(false);
          setShowVerifModal(true);
        })
        .catch((err) => {
          setSubmitVerifLoader(false);
          console.log(err);
          setErrorMessage(t("validation.error_connexion"));
        });
    }
  };

  const submitHandler = async () => {
    if (!submitLoader) {
      setErrorMessage("");
      setSubmitLoader(true);
      const TOKEN = await AsyncStorage.getItem("access_token");
      axios
        .post(process.env.USER_CHANGE_EMAIL, {
          access_token: TOKEN,
          email: emailValue.toLowerCase().trim(),
        })
        .then((res) => {
          setSubmitLoader(false);
          setShowValidateEmail(true);
        })
        .catch((err) => {
          //   console.log(err);
          if (err.response.status === 401) {
            setSubmitLoader(false);
            setErrorMessage(t("signup.error_email"));
            scrollToTop();
          } else if (err.response.status === 409) {
            setSubmitLoader(false);
            setErrorMessage(t("account_details_screen.error_email_used"));
            scrollToTop();
          } else {
            setErrorMessage(t("signin.error_connexion"));
            setSubmitLoader(false);
            scrollToTop();
          }
        });
    }
  };

  useEffect(() => {
    if (email.trim() == emailValue.trim() || emailValue.trim() == "") {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [emailValue, email, setIsDisabled]);

  return (
    <View style={{ marginBottom: 20 }}>
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <EmailIcon />
        <H6 style={{ marginLeft: 5 }}>{t("account_details_screen.email")}</H6>
        {status == "active" && (
          <View
            style={{ width: 14, height: 14, marginLeft: 2, marginTop: -15 }}
          >
            <Check />
          </View>
        )}
      </View>
      {/** message appear if email is not verified */}
      {status != "active" && showWarningMessage && (
        <View
          style={{
            padding: 10,
            backgroundColor: colors.red1,
            borderRadius: 10,
            marginVertical: 10,
          }}
        >
          <TouchableOpacity
            style={{
              width: 25,
              height: 25,
              alignSelf: "flex-end",
              padding: 5,
            }}
            onPress={() => setShowWarningMessage(false)}
          >
            <CloseIcon color={colors.white} />
          </TouchableOpacity>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Ionicons name="ios-warning-outline" size={20} color="white" />
            <View style={{ marginLeft: 4 }}>
              <SmallBoldTxt color={colors.white}>
                {t("account_details_screen.text6")} | {email}
              </SmallBoldTxt>
            </View>
          </View>
          <SmallTxt style={{ marginTop: 5 }} color={colors.white}>
            {t("account_details_screen.text7")}
          </SmallTxt>
          {/** verification number button */}
          <SecondaryButton
            width={200}
            onPress={verifHandler}
            isWhite={true}
            style={{ alignSelf: "flex-end", marginTop: 15 }}
          >
            {submitVerifLoder ? (
              <Spinner color="white" size="small" />
            ) : (
              t("account_details_screen.verif")
            )}
          </SecondaryButton>
        </View>
      )}
      <View
        style={{
          flexDirection: isDesktop ? "row" : "column",
          alignItems: isDesktop ? "center" : "stretch",
          justifyContent: isDesktop ? "space-between" : "flex-start",
        }}
      >
        <View style={{ flex: 1, marginRight: isDesktop ? 30 : 0 }}>
          <Input
            placeholder={t("placeholders.email")}
            value={emailValue}
            onChangeText={(val) => setEmailValue(val)}
          />
        </View>

        <PrimaryButton
          disabled={isDisabled}
          style={{ alignSelf: "center", marginTop: isDesktop ? 10 : 20 }}
          width={200}
          onPress={submitHandler}
        >
          {submitLoader ? (
            <Spinner
              color={submitLoader ? colors.white : colors.blue3}
              size="small"
            />
          ) : (
            t("account_details_screen.change_email")
          )}
        </PrimaryButton>
      </View>
      {/** pop up to put the validation code for email change  */}
      <ValidateChangeEmail
        isOpen={showValidateEmail}
        setIsOpen={setShowValidateEmail}
        newEmail={emailValue}
        setEmailValue={setEmailValue}
      />
      {/** pop up to validate current email address */}
      <ValidateEmail
        setShowVerifModal={setShowVerifModal}
        isOpen={showVerifModal}
        setIsOpen={setShowVerifModal}
      />
    </View>
  );
};

export default ChangeEmail;
